<template>
  <div>
    <b-container>
      <steps-menu
        v-show="false"
        :current-step="currentStep"
        :tab-menu="tabMenu"
        @stepChanged="stepChanged"/>

      <DossierOperationInvestissement
        v-if="currentStep === 0"
        ref="investissements"
        :currentStep="currentStep"
        :dossierId="dossierId"
        :investmentCreationDone="investmentCreationDone"
        @didChangeValue="emitChangeValue"
        @didContinue="didContinue"/>

      <DossierOperationEDM
        v-if="currentStep === 1"
        ref="edm"
        :currentStep="currentStep"
        :dossierId="dossierId"
        :edmCreationDone="edmCreationDone"
        :investmentId="investmentId"
        @didBack="didBack"
        @didChangeValue="emitChangeValue"
        @didContinueEDM="didContinueEDM"/>


      <DossierOperationCadastre
        v-if="currentStep === 2"
        ref="cadastre"
        :cadastraleCreationDone="cadastraleCreationDone"
        :currentStep="currentStep"
        :dossierId="dossierId"
        :investmentId="investmentId"
        @didBack="didBack"
        @didChangeValue="emitChangeValue"
        @didContinueCadastre="didContinueCadastre"/>

      <DossierOperationPlans
        v-if="currentStep === 3"
        ref="plans"
        :currentStep="currentStep"
        :dossierId="dossierId"
        :investmentId="investmentId"
        :plansCreationDone="plansCreationDone"
        @didBack="didBack"
        @didChangeValue="emitChangeValue"
        @didContinuePlans="didContinuePlans"/>


    </b-container>
  </div>

</template>

<script>

import StepsMenu from "../../../components/b122/stepsMenu";
import i18n from '../../../i18n'
import BackArrow from '../../../components/b122/BackArrow'
import DossierOperationCadastre from './DossierOperationCadastre'
import DossierOperationDemandeFinancement from './DossierOperationDemandeFinancement'
import DossierOperationEDM from './DossierOperationEDM'
import DossierOperationInformations from './DossierOperationInformations'
import DossierOperationSituation from './DossierOperationSituation'
import DossierOperationPlans from './DossierOperationPlans'


import api from "../../../services/api";
import DossierOperationInvestissement from "./DossierOperationInvestissement";

export default {

  name: "DossierOperationInvestissementStep",

  components: {
    DossierOperationInvestissement,
    DossierOperationSituation,
    StepsMenu,
    i18n,
    BackArrow,
    DossierOperationCadastre,
    DossierOperationDemandeFinancement,
    DossierOperationEDM,
    DossierOperationInformations,
    DossierOperationPlans
  },

  props: {
    dossierId: Number,
  },

  data() {
    return {
      investmentId: null,
      currentStep: -1,
      edmCreationDone: false,
      cadastraleCreationDone: false,
      plansCreationDone: false,
      investmentCreationDone: false
    }
  },

  emits: ['didContinueInvestissement', 'didChangeValue'],

  computed: {
    tabMenu() {
      return [
        i18n.t('operation.dossier.menu3.1'),
        i18n.t('operation.dossier.menu3.2'),
        i18n.t('operation.dossier.menu3.3'),
        i18n.t('operation.dossier.menu3.4'),
      ]
    },
    lastActiveStep() {
      if (this.plansCreationDone) {
        return 3
      } else if (this.cadastraleCreationDone) {
        return 2
      } else if (this.edmCreationDone) {
        return 1
      } else {
        return 0
      }
    },
  },

  async mounted() {
    await this.fetchData()
    this.currentStep = 0
  },

  methods: {

    async fetchData() {
      if (this.dossierId) {
        await this.fetchDossier()
      }
    },

    async fetchDossier() {
      await api
        .get(`/dossierOperation/${this.dossierId}`)
        .then(response => {
          this.investmentCreationDone = response.data.investmentCreationDone
          this.fundingRequestCreationDone = response.data.fundingRequestCreationDone
          this.financialCreationDone = response.data.financialCreationDone
          this.situationCreationDone = response.data.situationCreationDone
          this.edmCreationDone = response.data.etudeMarcheCreationDone
          this.cadastraleCreationDone = response.data.cadastraleCreationDone
          this.plansCreationDone = response.data.plansCreationDone
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'OperationIndex',
              params: {
                message: error.response.data.message
              }
            })
          }
        })
    },

    async emitChangeValue() {
      this.$emit('didChangeValue')
    },

    stepChanged(index) {
      this.currentStep = index
    },

    didBack() {
      this.currentStep--
    },

    incrementStep() {
      this.currentStep++
    },

    async didContinue(investmentId) {
      this.investmentCreationDone = true
      this.investmentId = investmentId
      this.incrementStep()
    },

    async didContinueEDM() {
      this.edmCreationDone = true
      this.incrementStep()
    },

    async didContinueCadastre() {
      this.cadastraleCreationDone = true
      this.incrementStep()
    },

    async didContinuePlans() {
      this.plansCreationDone = true
      this.$emit("didContinueInvestissement")
    },

    async didContinueInvestissement() {
      this.investmentCreationDone = true
      this.incrementStep()
    },


  }

}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/operationDossier/dossierOperationCreateSteps/DossierOperationInvestissementStep.vue